import { html, css, svg, LitElement } from 'lit';
import { NexusComponent } from "./nexus.component";

class TicketsOrderOverviewComponent extends NexusComponent {
    static shadowRootOptions = { ...LitElement.shadowRootOptions, mode: 'open', delegatesFocus: true };
    static properties = {
        data: {
            // state: true,
            // attribute: 'data',
            // reflect: true,
        },
        ecommerce: {
            // state: true,
            // attribute: 'data',
            // reflect: true,
        },
        validDiscountCode: {
            // type: Boolean,
            // state: true,
            attribute: 'validDiscountCode',
            reflect: true,
        },
        checkingCodeValidity: {
            // type: Boolean,
            // state: true,
            attribute: 'checkingCodeValidity',
            reflect: true,
        },
        theme: {
            attribute: 'theme',
            reflect: true,
        },
    };
    constructor() {
        super();
        this.total = 0.00;
        this.data = {
            tickets: new Map(),
            discounts: new Map(),
            total: 0.00,
            totalWithoutDiscounts: 0.00
        };
        this.theme = 'light';
        this.validDiscountCode = null;
        this.checkingCodeValidity = false;
        this.ticketInputName = 'ticket_input';
        this.showMaxNumberOfDiscounts = false;
        this.ecommerce = {};
        this.addEventListener('click', this.handleClick);
        this.addEventListener('input', this.handleInput);
    }
    static get styles() {
        // Write styles in standard CSS
        // https://stackoverflow.com/questions/25193964/how-can-i-have-a-web-components-width-and-height-be-inherited-by-its-children
        return css`
			:host {
                display: block;  /* or display: block; */
                position: relative;
                margin: 0;
                width: 100%;
			}
            :host([validdiscountcode="true"]) {
                .ticket-info-box {
                    display: block;
                }
            }
		`;
    }

    connectedCallback() {
        super.connectedCallback();
        let theme = this.closest('[data-bs-theme]');
        if (theme) {
            this.dataset.bsTheme = theme.dataset.bsTheme;
            this.theme = this.dataset.bsTheme;
        }
        this.setSubmitVisibility();
    }

    // handleFormSubmit = (event) => {
    // }

    handleInput = (event) => {
        // event.preventDefault();
        console.log('handleInput', event);
        // console.log('this...', this);
        // if (event.target.classList.contains('ticket-option-input')) {
        //     console.log('ticket option input!');
        //     this.data.tickets[event.target.getAttribute('name')] = event.target.value;
        // }
        // console.log('data', this.data.tickets);
        // // to get a reactive object property, you must make a new object,
        // // because otherwise the object is the same, only the properties change
        // this.data.tickets = Object.assign({}, this.data.tickets);
        // // manually request a data update given an input change,
        // // for updating tickets-flow js template
        // this.requestUpdate();
        // this.triggerEventOnElement('input', this);

    }

    handleTentativeDiscountCodeInput = (event) => {
        console.log('handleTentativeDiscountCodeInput', event);
        this.checkingCodeValidity = null;
        this.validDiscountCode = null;
        this.handleValidation();

    }

    handleSlotChange(event) {
        console.log('handleSlotChange', event);
    }

    attributeChangedCallback(name, _old, value) {
        super.attributeChangedCallback(name, _old, value);
        console.log('attributeChangedCallback', name, _old, value);
    }

    get _slottedChildren() {
        const slot = this.shadowRoot.querySelector('slot');
        return slot.assignedElements({ flatten: true });
    }

    /**
     * 
     * @param {PointerEvent} event 
     */
    handleClick(event) {
        const path = event.composedPath();
        const isHandledBySpecificHandler = path.some(el =>
            el.classList &&
            (el.classList.contains('ticket-option-button-decrease'))
        );
    
        if (isHandledBySpecificHandler) return; // Skip if the event is already handled
    
        console.log(`handleClick tickets`, this.data.tickets);

        console.log('handleClick', event);
    }

    handleDecrease(event) {
        event.stopPropagation();
    
        const target = event.composedPath().find(el => el.classList?.contains('ticket-option-button-decrease'));

        if (!target) return;
    
        const ticketFieldName = target.nextElementSibling.name;
        const ticket = this.data.tickets.get(ticketFieldName);
        const valueField = target.closest(".ticket-option-amount-small")?.querySelector('.ticket-option-input');
    
        if (!ticket || !valueField) return;
    
        const currentValue = parseInt(valueField.value);
        const newValue = Math.max(ticket.value - 1, ticket.min);
    
        // Update the ticket value in the map
        this.data.tickets.forEach((value, key) => {
            if (key === ticketFieldName) {
                value.value = newValue;

                if (currentValue == 0 && newValue == 0) {
                    this.data.tickets.delete(key);
                }
            }
        });
    
        // Update input fields in the main view
        const targets = document.querySelectorAll(".ticket-option-input[name='" + ticketFieldName + "']");
        targets.forEach((target) => {
            target.value = newValue;
        });
    
        this.requestUpdate();
    }

    getIncreaseButtonDisabledState(ticket) {
        if (ticket.value === ticket.max) {
            return true;
        }
        return false;
    }

    getDecreaseButtonDisabledState(ticket) {
        if (ticket.value === ticket.min) {
            return true;
        }
        return false;
    }

    renderOrderOverview() {
        let items = [];
        this.total = 0; // reset total every time!
        if (this.data && this.data.tickets) {
            let iterableTickets = this.data.tickets;
            iterableTickets.forEach((t) => {
                let ticket = t;
                ticket.total = 0; // reset ticket data every time!
                // total = total + parseFloat(parseFloat(ticket.price).toFixed(2)); // ¯\_(ツ)_/¯
                let itemTotal = parseFloat(parseFloat(ticket.price).toFixed(2)) * parseFloat(ticket.value);
                this.total = this.total + itemTotal;
                ticket.total = itemTotal;
                console.log('ticket total would be', ticket.total);
            });
            this.data.total = this.total;
            this.data.totalWithoutDiscounts = this.total;
            console.log('grand total would be', this.total);

            // this.data.total = total;
            console.log('renderOrderOverview received data!', this.data, iterableTickets);
            if (typeof iterableTickets !== 'undefined') {
                iterableTickets.forEach((t, index) => {
                    let ticketField = index;
                    let ticket = t;
                    if (ticket && ticket.label && typeof ticket.price === 'number' && parseFloat(ticket.value) >= 0) {
                        // Hardcoded icon because we are in shadow dom
                        const trashIcon = svg`
                        <svg width="14" height="18" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg">
                            <title>Trash icon</title>
                            <path d="M11 6V16H3V6H11ZM9.5 0H4.5L3.5 1H0V3H14V1H10.5L9.5 0ZM13 4H1V16C1 17.1 1.9 18 3 18H11C12.1 18 13 17.1 13 16V4Z"/>
                        </svg>`;
                        const decreaseButtonContent = ticket.value === 0 ? trashIcon : '-';
                        
                        let item = html`
                        <tickets-input>
                            <div class="ticket-option">
                                <div class="row mb-4">
                                    <div class="col">
                                    <div class="component-has-dynamic-background-and-color">
                                        <div class="bg-highlighted-background">
                                            <h5 class="h6 ticket-label">${ticket.label}</h5>
                                        </div>
                                    </div>
                                    <div class="ticket-option-amount ticket-option-amount-small">
                                        <button @click="${(event) => this.handleDecrease(event)}" type="button" class="ticket-option-button ticket-option-button-decrease">${decreaseButtonContent}</button>
                                        <input name="${ticketField}" id="${ticketField}" class="ticket-option-input" type="number"
                                        value="${ticket.value}" .value="${ticket.value}" min="${ticket.min}" max="${ticket.max}" />
                                        <button .disabled="${this.getIncreaseButtonDisabledState(ticket)}" type="button" class="ticket-option-button ticket-option-button-increase">+</button>
                                    </div>
                                    <p class="small mb-0"></p>
                                    </div>
                                    <div class="col-auto d-flex flex-column align-items-end">
                                    <div class="component-has-dynamic-background-and-color">
                                        <div class="bg-highlighted-background">
                                        <p class="fw-bold mb-3 d-none"><span class="ticket-currency"></span><span class="ticket-price d-none">${ticket.price}</span></p>
                                        <p class="fw-bold mb-0"><span class="ticket-total">${this.formatNumberAsEuro(ticket.total)}</span></p>
                                        </div>
                                    </div>
                                    </div>
                                </div>
                            </div>
                        </tickets-input>

                        `;
                        items.push(item);
                    }
                });
            }
            if (this.data.discounts) {
                let fixedBalanceDiscounts = [];
                console.log('would receive discount(s)!', this.data.discounts);
                if (this.data.tickets && this.data.tickets.size && this.data.tickets.size > 0) {
                }
                this.data.discounts.forEach((discount) => {

                    // case 1: percentage discount on whole order
                    if (discount.percentage && discount.percentage > 0 && typeof discount.tickets == 'undefined') {
                        // if there is a valid code,
                        // and the discounts tickets array from json result not there,
                        // and a discount percentage is set
                        // then subtract the percentage from the existing data total and set it as order overview total
                        this.data.total = Math.max(0, this.data.total * (1 - (discount.percentage / 100))); // total must be 0 or more
                        this.total = this.data.total;
                    }

                    // case 2: fixed balance discount on whole order
                    if (
                        typeof discount.percentage !== 'undefined' &&
                        discount.percentage == 0 &&
                        discount.fixed_balance &&
                        discount.fixed_balance > 0
                        && typeof discount.tickets == 'undefined'
                    ) {
                        this.data.total = Math.max(0, this.data.total - discount.fixed_balance);
                        this.total = this.data.total;
                        // if (discount.description) {
                        //     items.push(html`
                        //         <p class="small text-success mb-0">
                        //             Er is een korting toegepast ${this.getOrderDiscountFixedBalanceAffixText(discount)}
                        //         </p>
                        //         `);
                        // }
                    }

                    // case 3: ticket-specific discounts
                    if (discount.percentage == 0 && typeof discount.tickets !== 'undefined') {
                        Object.entries(discount.tickets).forEach((discountTicket) => {
                            let ticketUniqueId = discountTicket[0];
                            let ticket = discountTicket[1];
                            console.log('discount ticket with unique id', ticketUniqueId, ':', ticket);
                            let getBy = `ticket_type[${ticketUniqueId}]`;
                            let getTentativeTicketByTicketUniqueId = this.data.tickets.get(getBy);
                            console.log('getBy parameter', getBy, 'and tickets data is', this.data.tickets, `and getTentativeTicketByTicketUniqueId`, getTentativeTicketByTicketUniqueId);
                            if (getTentativeTicketByTicketUniqueId) {

                                console.log('matched a tentative order ticket with a ticket-specific discount:', getBy);
                                // if this ticket-specific discount is present in the current tentative map of items to order
                                // then the ticket fixed_balance would be subtracted from the total
                                if (ticket.fixed_balance && ticket.max_order_amount) {
                                    // max_order_amount is an obligated field in CM UI.
                                    // Fixed balance deduction for specific tickets are handled
                                    console.log('ticket.fixed_balance', ticket.fixed_balance);
                                    this.data.total = Math.max(0, this.data.total - (Math.min(getTentativeTicketByTicketUniqueId.value, ticket.max_order_amount) * ticket.fixed_balance));
                                    this.total = this.data.total;
                                    // if (discount.description) {
                                    //     items.push(html`
                                    //             <p class="small text-success mb-0">
                                    //                 Er is een korting toegepast ${this.getTicketDiscountFixedBalanceAffixText(ticket)}
                                    //             </p>
                                    //         `);
                                    // }
                                }
                            }
                        });
                    }

                    // if (discount.percentage && discount.percentage > 0 && typeof discount.tickets == 'undefined' && discount.description) {
                    //     items.push(html`
                    //         <p class="small text-success mb-0">
                    //             Er is een korting toegepast ${this.getDiscountPercentageAffixText(discount)}
                    //         </p>
                    //         `);
                    // }
                    console.log('discount:', discount);
                });
            }
        }
        this.mapEcommerce();
        this.setPaymentMethodVisibility();
        this.setSubmitVisibility();
        return items;
    }

    setPaymentMethodVisibility() {
        // If the total is 0, hide the payment method select
        
        const paymentMethodContainer = document.querySelector('.ticket-payment-method');
        if (!paymentMethodContainer) return;

        const paymentMethodSelect = paymentMethodContainer.querySelector('#payment_method_id');
        if (!paymentMethodSelect) return;

        paymentMethodContainer.style.display = this.total <= 0 ? 'none' : '';

        if (this.total > 0) {
            paymentMethodSelect.setAttribute("required", "");
        } else {
            paymentMethodSelect.removeAttribute("required");
        }
    }

    setSubmitVisibility() {
        // If we the total without discounts is 0, disable the submit button, because there are no tickets in the cart
        const submitButton = document.querySelector('.submit-step');
        if (!submitButton) return;

        const canSubmit = this.data.totalWithoutDiscounts > 0;

        submitButton.classList.toggle("btn-primary", canSubmit);
        submitButton.classList.toggle("btn-outline-gray-100", !canSubmit);
        submitButton.classList.toggle("btn-gray-300", !canSubmit);
        submitButton.style.cursor = canSubmit ? "" : "not-allowed";
        submitButton.style.pointerEvents = "auto";
        submitButton.style.opacity = 1;

        if (!canSubmit) {
            const tooltip = "Je hebt geen tickets in je mandje. Voeg tickets toe om verder te gaan.";

            submitButton.setAttribute("disabled", "");
            submitButton.dataset.tooltip = tooltip;
        } else {
            submitButton.removeAttribute("disabled");
            submitButton.removeAttribute("data-tooltip");
        }
    }

    mapEcommerce() {
        this.data;
        this.ecommerce = {};
        this.ecommerce.value = this.total;
        this.ecommerce.currency = 'EUR';
        if (
            // this.validDiscountCode === true &&
            typeof this.data !== 'undefined' &&
            typeof this.data.discounts !== 'undefined'
        ) {
            console.log('discounts...', this.data.discounts);
            // console.log('discounts...', this.data.discounts, Object.entries(this.data.discounts)[0][1]);
            Object.entries(this.data.discounts).forEach((discount) => {
                this.ecommerce.coupon = discount.code;
            });
        }
        // this.ecommerce.items = this.data.tickets; // TODO: map
        this.ecommerce.items = [];
        let totalQuantity = 0;

        this.data.tickets.forEach((item, key) => {
            console.log('iterating ticket...', item);
            let ticketMapping = {
                item_id: key,
                item_name: item.label,
                item_brand: window.location.host,
                // item_category: null,
                price: item.price,
                quantity: item.value
            };
            totalQuantity += ticketMapping.quantity;
            this.ecommerce.items.push(ticketMapping)
        });

        if (this.data && this.data.tickets && typeof totalQuantity == 'number') {
            this.ecommerce.cart_quantity = totalQuantity;
        }

        // transaction_id
        // value (total)
        // currency => EUR
        // coupon
        // cart_quantity
        // items
        // item_id
        // item_name
        // item_brand
        // item_category
        // price
        // quantity

        console.log('mapEcommerce', this, this.data, this.ecommerce);
    }

    getDiscountPercentageAffixText(discount) {
        let template = html``;
        if (discount.percentage && typeof discount.tickets == 'undefined') {
            template = html`van ${discount.percentage}% van de totaalprijs.`;
        }
        return template;
    }

    /**
     * 
     * @param {*} ticket a discount ticket from a discount tickets result array 
     * @returns 
     */
    getOrderDiscountFixedBalanceAffixText(discount) {
        let template = html``;
        console.log('getDiscountFixedBalanceText');
        if (discount && discount.fixed_balance) {
            template = html`van &euro;${discount.fixed_balance} van de gehele bestelling.`;
        }
        return template;
    }

    /**
     * 
     * @param {*} ticket a discount ticket from a discount tickets result array 
     * @returns 
     */
    getTicketDiscountFixedBalanceAffixText(ticket) {
        let template = html``;
        if (ticket && ticket.fixed_balance && ticket.name && ticket.max_order_amount) {
            template = html`van &euro;${ticket.fixed_balance} op ticket <strong>${ticket.name}</strong>. ${this.renderMaxNumberOfDiscounts(ticket)}`;
        }

        return template;
    }

    renderMaxNumberOfDiscounts(ticket) {
        let template = html``;
        if (this.showMaxNumberOfDiscounts === true && ticket && ticket.max_order_amount) {
            template = html`Deze korting geldt maximaal ${ticket.max_order_amount} keer per bestelling van dit ticket.`;
        }
    }

    renderDiscountCodeElementClasses() {
        let classes = [
            'ticket-form',
            'ticket-discount',
            'align-items-stretch',
        ];
        // In CM, a coupon code can only be entered once per ticket reservation. So hide after first valid discount code
        if (this.validDiscountCode == true) {
            classes.push('d-none');
        }

        let concatenatedClasses = classes.join(' ');
        console.log('renderDiscountCodeElementClasses concatenatedClasses', concatenatedClasses);
        return concatenatedClasses;
    }

    /**
     * 
     * In CM, a coupon code can only be entered once per ticket reservation. So hide after first valid discount code
     * 
     * @returns text or hidden
     */
    getDiscountInputType() {
        let inputType = 'text';
        if (this.validDiscountCode === true) {
            inputType = 'hidden';
        }
        return inputType;
    }

    render() {
        return html`
            <link href="${this.styleSheetPrefix}/css/index2.css?v=123" rel="stylesheet" />
            <div data-bs-theme="${this.theme}" component-loaded>
                <div class="ticket-box tickets-order-overview bg-highlighted-background p-3">
                <div class="component-has-dynamic-background-and-color">
                    <div class="bg-highlighted-background">
                        <h4 class="mb-4">Jouw bestelling</h4>
                    </div>
                </div>
                    ${this.renderOrderOverview()}
                    <div class="ticket-info-box mt-3 mb-3 bg-info px-2 py-3">
                        <div class="row p-0 m-0">
                            <div class="col-auto px-1">
                                <slot name="logo"></slot>
                            </div>
                            <div class="col">
                                <p class="small lh-base mb-0 text-light"><slot name="silver">Meerdere codes verzilveren? Dit doe je één voor één. Kies 1 ticket en
                                verzilver deze met je code. Rond het proces af en herhaal het vervolgens met de volgende code.</slot></p>
                            </div>
                        </div>
                    </div>
                    <div class="${this.renderDiscountCodeElementClasses()}">
                        <div class="row mb-2 pe-0">
                            <div class="col">
                                <input @input="${this.handleTentativeDiscountCodeInput}" ?disabled="${this.checkingCodeValidity == true}" name="discount_code_to_try" id="discount_code_to_try" class="w-100 h-100 p-2 form-control" type="${this.getDiscountInputType()}" placeholder="Kortingscode toevoegen" />
                            </div>
                            <div class="col-auto">
                                <button ?disabled="${this.checkingCodeValidity == true}" type="button" class="btn btn-outline-primary button-discount-add">Voeg toe</button>
                            </div>
                        </div>
                    </div>
                    <div class="mb-3">
                        ${this.handleValidation()}
                    </div>
                    <div class="component-has-dynamic-background-and-color">
                        <div class="bg-highlighted-background">
                            ${  // Show subtotal and discount, if there is a discount
                                this.data.totalWithoutDiscounts !== this.data.total ? html`
                                <div class="d-flex justify-content-between align-items-center mb-1">
                                    <p class="p mb-0 text-gray-100 small">Subtotaal</p>
                                    <p class="mb-0 text-gray-100 small"><span class="ticket-currency"></span><span class="ticket-total">${this.formatNumberAsEuro(this.data.totalWithoutDiscounts)}</span></p>
                                </div>
                                <div class="d-flex justify-content-between align-items-center mb-2">
                                    <p class="p mb-0 text-primary"><strong>Korting</strong></p>
                                    <p class="mb-0 text-primary"><span class="ticket-currency"></span><span class="ticket-total"><strong>- ${this.formatNumberAsEuro(this.data.totalWithoutDiscounts - this.data.total)}</strong></span></p>
                                </div>
                            ` : ''}
                            <div class="d-flex justify-content-between align-items-center border-top border-gray-200 pt-2">
                                <h6 class="mb-0">Totaal</h6>
                                <h6 class="mb-0"><span class="ticket-currency"></span><span class="ticket-total">${this.formatNumberAsEuro(this.data.total.toFixed(2))}</span></h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
    }



    formatNumberAsEuro(number) {
        console.log('formatNumberAsEuro', number);
        // make a nice currency format based on document language!
        if (typeof Intl !== 'undefined') {
            return Intl.NumberFormat(document.documentElement.lang, { style: 'currency', currency: 'EUR' }).format(number)
        }

        // fallback
        return number.toFixed();
    }

    handleValidation() {
        let template = html``;
        console.log('handleValidation', this.validDiscountCode);
        if (this.checkingCodeValidity == true) {
            template = html`

<div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <div class="small p-2 rounded bg-light text-info rounded-2 mb-0">Momentje, we checken de code</div>
                    </div>
                </div>
            </div>
        </div>
           `
        }
        if (this.validDiscountCode == false) {
            template = html`
        <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <div class="small p-2 rounded bg-light text-danger rounded-2 mb-0">De kortingscode is niet geldig. Controleer of de code juist is ingevoerd en probeer het opnieuw.</div>
                    </div>
                </div>
            </div>
        </div>
        `;
        }
        if (this.validDiscountCode == true) {
            template = html`
           <div class="row">
            <div class="col-12">
                <div class="row">
                    <div class="col-12">
                        <div class="small p-2 rounded bg-light text-success rounded-2 mb-0">De couponcode is toegepast op je bestelling!</div>
                    </div>
                </div>
            </div>
           </div>
           `
        }
        return template;
    }
}

window.customElements.define('tickets-order-overview', TicketsOrderOverviewComponent);